import { types } from '../types/types';
import { BLOCK_EDITION, BLOG_EDITION } from '../constants/admin/blog_constants';

const initialState = {
    blog: { // blog del sitio
        posts: [],
        categories: []
    },
    blog_data: { // sección para administradores
        list: [],
        blogInEdition: BLOG_EDITION,
        blockInEdition: BLOCK_EDITION
    },
};

export const blogReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.blogSaved:
            return {
                ...state,
                blog_data: {
                    ...state.blog_data,
                    list: [...state.blog_data.list, action.payload]
                }
            };
        case types.blogUpdated:
            return {
                ...state,
                blog_data: {
                    ...state.blog_data,
                    list: state.blog_data.list.map(e =>
                        (e._id === action.payload._id) ?
                            { ...e, ...action.payload }
                        : e
                    )
                }
            };
        case types.blogDeleted:
            return {
                ...state,
                blog_data: {
                    ...state.blog_data,
                    list: state.blog_data.list.filter(
                        e => (e._id !== action.payload)
                    )
                }
            };
        case types.blogInEdition:
            return {
                ...state,
                blog_data: {
                    ...state.blog_data,
                    blogInEdition: {
                        ...state.blog_data.blogInEdition,
                        ...action.payload
                    }
                }
            };
        case types.blockInEdition:
            return {
                ...state,
                blog_data: {
                    ...state.blog_data,
                    blockInEdition: {
                        ...state.blog_data.blockInEdition,
                        ...action.payload
                    }
                }
            };
        case types.blogListLoaded:
            return {
                ...state,
                blog_data: {
                    ...state.blog_data,
                    list: action.payload
                }
            };
        case types.blogCategorySelected:
            return {
                ...state,
                blog: {
                    ...state.blog,
                    categories: [...action.payload]
                }
            };
        case types.blogCategorySaved:
            return {
                ...state,
                blog: {
                    ...state.blog,
                    categories: [...state.blog.categories, action.payload]
                }
            };
        case types.blogCategoryDeleted: {
            const { category_id } = action.payload
            return {
                ...state,
                blog: {
                    ...state.blog,
                    categories: [
                        ...state.blog.categories.filter(({ _id }) => _id !== category_id)
                    ]
                }
            };
        };
        case types.nefroBlogLoaded:
            return {
                ...state,
                blog: {
                    ...state.blog,
                    ...action.payload
                }
            };
        default:
            return state;
    };
};